import styles from './styles.less';
import { observer } from 'mobx-react';


function CategoryNavItem(props) {
    const className = cx(styles.item, props.className, {
        [styles.selectedItem]: props.selected,
        [props.selectedClassName]: props.selectedClassName && props.selected
    });
    return (
        <li className={ className }>
            <span
                className={ cx(styles.itemContent, props.contentClassName) }
                onClick={ () => props.onClick(props.category) }>
                { props.children }
            </span>
        </li>
    );
}

CategoryNavItem.propTypes = {
    category: React.PropTypes.string.isRequired,
    contentClassName: React.PropTypes.string,
    onClick: React.PropTypes.func.isRequired,
    selected: React.PropTypes.bool.isRequired,
    selectedClassName: React.PropTypes.string
};

CategoryNavItem.defaultProps = {
    selected: false
};


export default observer(CategoryNavItem);



// WEBPACK FOOTER //
// ./src/common/components/category-nav/item.js